var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9989 20.2882C19.8279 21.4592 17.9282 21.4587 16.7577 20.2882C15.9353 19.4659 15.7033 18.2885 16.0353 17.2528L16.0241 17.2522L19.1371 6.39686L21.7657 17.3602L21.7528 17.3602C22.0341 18.3697 21.7924 19.4947 20.9989 20.2882Z",
    fill: "#36ACD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72197 5.0557C9.79505 2.36978 13.7657 0.65478 18.3027 0.398438V4.95588C14.5219 5.19635 12.2942 6.39715 10.0574 8.27094L6.72197 5.0557Z",
    fill: "#36ACD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58184 17.9254H0.0296869C0.33518 13.3883 2.10992 9.6604 4.8654 6.60547L8.08594 9.80634C6.1456 12.0295 4.86918 14.9007 4.58184 17.9254Z",
    fill: "#36ACD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55999 20.1927C5.04167 27.7545 11.3066 33.7517 18.959 33.7517C26.9253 33.7517 33.6446 27.2909 33.6446 19.3254C33.6446 11.7425 27.3767 5.53814 20.5712 4.95588V0.398438C30.4014 0.987495 38.1816 9.2585 38.1816 19.3451C38.1816 29.8128 29.5462 38.2887 19.0785 38.2887C8.92159 38.2887 0.484222 30.023 -0.000484467 20.1927H4.55999Z",
    fill: "#36ACD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedThree);
export default __webpack_public_path__ + "static/media/SpeedThree.3efd5e0848cbaaa54f6bc3c94ce7d779.svg";
export { ForwardRef as ReactComponent };